// =====================================================
// Accessibility helpers
// =====================================================

function makeAccessibleButton($el, label, onActivate) {
  if (!$el.length) return;

  if (!$el.is('button')) {
    $el.attr({
      tabindex: 0,
      role: 'button',
      'aria-label': label,
    });
  }

  $el.off('keydown.accessibleBtn').on('keydown.accessibleBtn', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });

  // Binds an optional click handler using a namespaced event to avoid duplicated listeners.
  if (onActivate) {
    $el.off('click.accessibleBtn').on('click.accessibleBtn', onActivate);
  }
}

// =====================================================
// Header / Navigation patches
// =====================================================

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const closeToggle = $('.close-mobile-menu');

  if (!navToggle.length || navToggle.data('patched')) return;
  navToggle.data('patched', true);

  navToggle.html(`
    
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
      fill="var(--theme-color-primary)" width="24" height="24" aria-hidden="true" focusable="false">
      <path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/>
    </svg>
  `);

  // Open menu → move focus inside when menu is actually open
  makeAccessibleButton(navToggle, 'Open menu', () => {
    requestAnimationFrame(() => {
      if ($('body').hasClass('mobile-menu-open') && closeToggle.length) {
        closeToggle.attr('tabindex', 0).focus();
      }
    });
  });

  // Close menu → return focus to toggle when menu is actually closed
  makeAccessibleButton(closeToggle, 'Close menu', () => {
    requestAnimationFrame(() => {
      if (!$('body').hasClass('mobile-menu-open')) {
        navToggle.focus();
      }
    });
  });
}

function modifySearchBox() {
  const searchInput = $('.header .inputFieldTextbox');
  const searchButton = $('.header .searchSubmitButton'); // <a> with onclick

  searchInput.attr('placeholder', 'Type here...');
  searchButton.attr('tabindex', '-1');
  searchButton.attr('aria-label', 'submit search');
}

// =====================================================
// Weather widget patch
// =====================================================

function modifyWeatherBug() {
  const widget = document.getElementById('weatherBugWidget');
  const desc = document.getElementById('weatherBugDescription');
  if (!widget || !desc) return;

  const observer = new MutationObserver(() => {
    const text = desc.textContent.trim();
    if (!text || widget.classList.contains('weatherBugSet')) return;

    widget.classList.add('weatherBugSet');

    const lastSpace = text.lastIndexOf(' ');
    if (lastSpace !== -1) {
      desc.textContent = text.substring(lastSpace + 1);
    }

    observer.disconnect();
  });

  observer.observe(desc, { childList: true, subtree: true });
}

// =====================================================
// Signup patch
// =====================================================

function modifySignup() {
  const signup = $('.emailSignup');
  if (!signup.length) return;

  const input = signup.find('.inputFieldTextbox');
  const submit = signup.find('.emailSubmitButton');

  signup.find('.emailSignupText').remove();

  input.val('').attr('placeholder', 'Email Address');

  submit.text('SUBSCRIBE').attr('aria-label', 'Subscribe to newsletter');
}

// =====================================================
// Header height observer
// =====================================================

function observeHeaderHeight(selector = 'header', { offset = 0 } = {}) {
  const header = document.querySelector(selector);
  if (!header || !('ResizeObserver' in globalThis)) return { destroy() {} };

  let lastHeight = null;
  let scheduled = false;

  function measure() {
    const rect = header.getBoundingClientRect();
    const style = getComputedStyle(header);
    return Math.round(rect.height + Number.parseFloat(style.marginBottom || 0) + offset);
  }

  function apply() {
    scheduled = false;
    const h = measure();
    if (h !== lastHeight) {
      lastHeight = h;
      document.documentElement.style.setProperty('--theme-header-height', `${h}px`);
    }
  }

  function schedule() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(apply);
    }
  }

  const ro = new ResizeObserver(schedule);
  ro.observe(header);
  schedule();

  return {
    destroy() {
      ro.disconnect();
    },
  };
}

// =====================================================
// Feature Lineup patch
// =====================================================

function modifyFeatureLineup() {
  const lineups = $('.featureLineupContainer');
  if (!lineups.length) return;

  lineups.each((_, el) => {
    const $lineup = $(el);
    const containerWidth = $lineup.width();
    const buttonContainer = $lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const cta = buttonContainer.find('.featureLineup-buynow');

    if (!icons.children().length) {
      icons.remove();
      return;
    }

    const totalWidth = icons.outerWidth(true) + cta.outerWidth(true);

    if (totalWidth > containerWidth) {
      buttonContainer.addClass('column');
    }
  });
}

$(document).ready(() => {
  $('.generalmessage').prependTo('header');
  modifyBtnNavToggle();
  modifySearchBox();
  modifySignup();
  modifyFeatureLineup();
  modifyWeatherBug();
  makeAccessibleButton($('.close-mobile-menu'), 'Close menu');
  observeHeaderHeight('.header');
});
